<template>
    <v-row dense class="px-5">
        <v-col cols="12">
            <h5 class="text-center mb-5">30 Days</h5>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Currency</th>
                            <th class="text-right">StartingValue</th>
                            <th class="text-right">ROE</th>
                            <th class="text-right">P/L</th>
                            <th class="text-right">EndingValue</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in portfolioResult.day30" :key="index">
                            <td class="font-12">{{item.symbol}}</td>
                            <td class="font-12 text-right">${{formatNum(item.starting.toFixed(2))}}</td>
                            <td class="font-12 text-right" :class="item.roe < 0 ? 'red--text' : ''">{{(item.roe * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right" :class="item.pl < 0 ? 'red--text' : ''">${{formatNum(item.pl.toFixed(2))}}</td>
                            <td class="font-12 text-right">${{formatNum(item.ending.toFixed(2))}}</td>
                        </tr>
                        <tr>
                            <td class="font-12">Total</td>
                            <td class="font-12 text-right">${{formatNum(starting30)}}</td>
                            <td class="font-12 text-right">{{((ending30 - starting30) / starting30 * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right">${{formatNum(pl30)}}</td>
                            <td class="font-12 text-right">${{formatNum(ending30)}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="mt-5">
          <h5 class="text-center mb-5">60 Days</h5>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Currency</th>
                            <th class="text-right">StartingValue</th>
                            <th class="text-right">ROE</th>
                            <th class="text-right">P/L</th>
                            <th class="text-right">EndingValue</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in portfolioResult.day60" :key="index">
                            <td class="font-12">{{item.symbol}}</td>
                            <td class="font-12 text-right">${{formatNum(item.starting.toFixed(2))}}</td>
                            <td class="font-12 text-right" :class="item.roe < 0 ? 'red--text' : ''">{{(item.roe * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right" :class="item.pl < 0 ? 'red--text' : ''">${{formatNum(item.pl.toFixed(2))}}</td>
                            <td class="font-12 text-right">${{formatNum(item.ending.toFixed(2))}}</td>
                        </tr>
                        <tr>
                            <td class="font-12">Total</td>
                            <td class="font-12 text-right">${{formatNum(starting60)}}</td>
                            <td class="font-12 text-right">{{((ending60 - starting60) / starting60 * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right">${{formatNum(pl60)}}</td>
                            <td class="font-12 text-right">${{formatNum(ending60)}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="mt-5">
          <h5 class="text-center mb-5">1 Quarter</h5>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Currency</th>
                            <th class="text-right">StartingValue</th>
                            <th class="text-right">ROE</th>
                            <th class="text-right">P/L</th>
                            <th class="text-right">EndingValue</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in portfolioResult.day90" :key="index">
                            <td class="font-12">{{item.symbol}}</td>
                            <td class="font-12 text-right">${{formatNum(item.starting.toFixed(2))}}</td>
                            <td class="font-12 text-right" :class="item.roe < 0 ? 'red--text' : ''">{{(item.roe * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right" :class="item.pl < 0 ? 'red--text' : ''">${{formatNum(item.pl.toFixed(2))}}</td>
                            <td class="font-12 text-right">${{formatNum(item.ending.toFixed(2))}}</td>
                        </tr>
                        <tr>
                            <td class="font-12">Total</td>
                            <td class="font-12 text-right">${{formatNum(starting90)}}</td>
                            <td class="font-12 text-right">{{((ending90 - starting90) / starting90 * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right">${{formatNum(pl90)}}</td>
                            <td class="font-12 text-right">${{formatNum(ending90)}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="mt-5">
          <h5 class="text-center mb-5">6 Months</h5>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Currency</th>
                            <th class="text-right">StartingValue</th>
                            <th class="text-right">ROE</th>
                            <th class="text-right">P/L</th>
                            <th class="text-right">EndingValue</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in portfolioResult.day180" :key="index">
                            <td class="font-12">{{item.symbol}}</td>
                            <td class="font-12 text-right">${{formatNum(item.starting.toFixed(2))}}</td>
                            <td class="font-12 text-right" :class="item.roe < 0 ? 'red--text' : ''">{{(item.roe * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right" :class="item.pl < 0 ? 'red--text' : ''">${{formatNum(item.pl.toFixed(2))}}</td>
                            <td class="font-12 text-right">${{formatNum(item.ending.toFixed(2))}}</td>
                        </tr>
                        <tr>
                            <td class="font-12">Total</td>
                            <td class="font-12 text-right">${{formatNum(starting180)}}</td>
                            <td class="font-12 text-right">{{((ending180 - starting180) / starting180 * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right">${{formatNum(pl180)}}</td>
                            <td class="font-12 text-right">${{formatNum(ending180)}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="mt-5">
            <h5 class="text-center mb-5">Since Inception</h5>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Currency</th>
                            <th class="text-right">StartingValue</th>
                            <th class="text-right">ROE</th>
                            <th class="text-right">P/L</th>
                            <th class="text-right">EndingValue</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in portfolioResult.day360" :key="index">
                            <td class="font-12">{{item.symbol}}</td>
                            <td class="font-12 text-right">${{formatNum(item.starting.toFixed(2))}}</td>
                            <td class="font-12 text-right" :class="item.roe < 0 ? 'red--text' : ''">{{(item.roe * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right" :class="item.pl < 0 ? 'red--text' : ''">${{formatNum(item.pl.toFixed(2))}}</td>
                            <td class="font-12 text-right">${{formatNum(item.ending.toFixed(2))}}</td>
                        </tr>
                        <tr>
                            <td class="font-12">Total</td>
                            <td class="font-12 text-right">${{formatNum(starting360)}}</td>
                            <td class="font-12 text-right">{{((ending360 - starting360) / starting360 * 100).toFixed(2)}}%</td>
                            <td class="font-12 text-right">${{formatNum(pl360)}}</td>
                            <td class="font-12 text-right">${{formatNum(ending360)}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue';
    import config from '../../config';
    import {mapGetters} from "vuex";
    // 引入导出Excel表格依赖
    import FileSaver from "file-saver";
    import XLSX from "xlsx";

    export default {
        data() {
            return {
                portfolioResult:[],
            }
        },
        computed: {
            ...mapGetters(['user']),
            starting30(){
                var total = 0;
                if(this.portfolioResult.day30 != null && this.portfolioResult.day30.length > 0){
                    for(var i = 0; i < this.portfolioResult.day30.length ; i++){
                        total += this.portfolioResult.day30[i].starting;
                    }
                }
                return total.toFixed(2);
            },
            pl30(){
                var total = 0;
                if(this.portfolioResult.day30 != null && this.portfolioResult.day30.length > 0){
                    for(var i = 0; i < this.portfolioResult.day30.length ; i++){
                        total += this.portfolioResult.day30[i].pl;
                    }
                }
                return total.toFixed(2);
            },
            ending30(){
                var total = 0;
                if(this.portfolioResult.day30 != null && this.portfolioResult.day30.length > 0){
                    for(var i = 0; i < this.portfolioResult.day30.length ; i++){
                        total += this.portfolioResult.day30[i].ending;
                    }
                }
                return total.toFixed(2);
            },
            starting60(){
                var total = 0;
                if(this.portfolioResult.day60 != null && this.portfolioResult.day60.length > 0){
                    for(var i = 0; i < this.portfolioResult.day60.length ; i++){
                        total += this.portfolioResult.day60[i].starting;
                    }
                }
                return total.toFixed(2);
            },
            pl60(){
                var total = 0;
                if(this.portfolioResult.day60 != null && this.portfolioResult.day60.length > 0){
                    for(var i = 0; i < this.portfolioResult.day60.length ; i++){
                        total += this.portfolioResult.day60[i].pl;
                    }
                }
                return total.toFixed(2);
            },
            ending60(){
                var total = 0;
                if(this.portfolioResult.day60 != null && this.portfolioResult.day60.length > 0){
                    for(var i = 0; i < this.portfolioResult.day60.length ; i++){
                        total += this.portfolioResult.day60[i].ending;
                    }
                }
                return total.toFixed(2);
            },
            starting90(){
                var total = 0;
                if(this.portfolioResult.day90 != null && this.portfolioResult.day90.length > 0){
                    for(var i = 0; i < this.portfolioResult.day90.length ; i++){
                        total += this.portfolioResult.day90[i].starting;
                    }
                }
                return total.toFixed(2);
            },
            pl90(){
                var total = 0;
                if(this.portfolioResult.day90 != null && this.portfolioResult.day90.length > 0){
                    for(var i = 0; i < this.portfolioResult.day90.length ; i++){
                        total += this.portfolioResult.day90[i].pl;
                    }
                }
                return total.toFixed(2);
            },
            ending90(){
                var total = 0;
                if(this.portfolioResult.day90 != null && this.portfolioResult.day90.length > 0){
                    for(var i = 0; i < this.portfolioResult.day90.length ; i++){
                        total += this.portfolioResult.day90[i].ending;
                    }
                }
                return total.toFixed(2);
            },
            starting180(){
                var total = 0;
                if(this.portfolioResult.day180 != null && this.portfolioResult.day180.length > 0){
                    for(var i = 0; i < this.portfolioResult.day180.length ; i++){
                        total += this.portfolioResult.day180[i].starting;
                    }
                }
                return total.toFixed(2);
            },
            pl180(){
                var total = 0;
                if(this.portfolioResult.day180 != null && this.portfolioResult.day180.length > 0){
                    for(var i = 0; i < this.portfolioResult.day180.length ; i++){
                        total += this.portfolioResult.day180[i].pl;
                    }
                }
                return total.toFixed(2);
            },
            ending180(){
                var total = 0;
                if(this.portfolioResult.day180 != null && this.portfolioResult.day180.length > 0){
                    for(var i = 0; i < this.portfolioResult.day180.length ; i++){
                        total += this.portfolioResult.day180[i].ending;
                    }
                }
                return total.toFixed(2);
            },
            starting360(){
                var total = 0;
                if(this.portfolioResult.day360 != null && this.portfolioResult.day360.length > 0){
                    for(var i = 0; i < this.portfolioResult.day360.length ; i++){
                        total += this.portfolioResult.day360[i].starting;
                    }
                }
                return total.toFixed(2);
            },
            pl360(){
                var total = 0;
                if(this.portfolioResult.day360 != null && this.portfolioResult.day360.length > 0){
                    for(var i = 0; i < this.portfolioResult.day360.length ; i++){
                        total += this.portfolioResult.day360[i].pl;
                    }
                }
                return total.toFixed(2);
            },
            ending360(){
                var total = 0;
                if(this.portfolioResult.day360 != null && this.portfolioResult.day360.length > 0){
                    for(var i = 0; i < this.portfolioResult.day360.length ; i++){
                        total += this.portfolioResult.day360[i].ending;
                    }
                }
                return total.toFixed(2);
            }
        },
        watch: {},
        mounted() {
            if (!this.user.token) {
                this.$router.push({
                    name: 'login'
                })
            };
            this.getResult();
        },
        created() {

        },
        methods: {
            getResult(){
                let api = config.baseUrl + '/admin/private/getPortfolioResult';
                this.$http.get(api).then(res=>{
                    let data = res.data;
                    if(data.code == 200){
                        this.portfolioResult = data.result;
                    }
                })
            },
            //定义导出Excel表格事件
            exportExcel() {
                /* 从表生成工作簿对象 */
                var today = new Date()
                var wb = XLSX.utils.table_to_book(document.querySelector("#Portfolio"));
                /* 获取二进制字符串作为输出 */
                var wbout = XLSX.write(wb, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        //Blob 对象表示一个不可变、原始数据的类文件对象。
                        //Blob 表示的不一定是JavaScript原生格式的数据。
                        //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                        //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                        new Blob([wbout], {type: "application/octet-stream"}),
                        //设置导出文件名称
                        "Portfolio" + this.common.dateFormat(today) + ".xlsx"
                    );
                } catch (e) {
                    if (typeof console !== "undefined") console.log(e, wbout);
                }
                return wbout;
            },
            // 四舍五入 保留小数
            getFloat(num, n) {
                n = n ? parseInt(n) : 0;
                if (n <= 0) {
                    return Math.round(num);
                }
                num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
                num = Number(num).toFixed(n); //补足位数
                return num;
            },
            // 首字母大写
            toFirstLetterUpperCase(message) {
                if (message) {
                    return message.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
                } else {
                    return null;
                }
            },
            dateFormat(time) {
                var date = new Date(time);
                var year = date.getFullYear();
                /* 在日期格式中，月份是从0开始的，因此要加0
                 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
                 * */
                var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
                var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                // 拼接
                return (day + "/" + month + "/" + year);
            },
            // 货币格式化
            formatNum(num) {
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
    }
</script>